/**
 * Borde de papel rasgado a todo lo ancho: la sección de abajo aparece como
 * una hoja ARRANCADA sobre la de arriba, no separada por una regla recta.
 * Es la versión a escala completa del mismo lenguaje que ya usan el sello
 * perforado y PerforatedDivider — aquí como momento principal, no detalle.
 *
 * El trazo se genera una sola vez al cargar el módulo con un PRNG
 * DETERMINISTA (xorshift con semilla fija): así el prerender del build y el
 * navegador dibujan exactamente el mismo rasgado — si fuera Math.random()
 * habría un trazo distinto en el HTML pre-renderizado y otro al hidratar.
 */
const W = 1440;
const H = 34;

function buildTear(seed) {
    let s = seed;
    const rand = () => {
        s ^= s << 13;
        s ^= s >>> 17;
        s ^= s << 5;
        return ((s >>> 0) % 10000) / 10000;
    };

    const steps = 220;
    const points = [];
    for (let i = 0; i <= steps; i++) {
        const x = (i / steps) * W;
        // Tres escalas superpuestas: ondulación larga (la dirección del
        // rasgón), rizado corto (la fibra) y ruido fino. Un rasgado real no
        // es una onda limpia ni un zigzag regular: es irregular a la vez en
        // varios tamaños, y por eso se lee como papel y no como decoración.
        const macro = Math.sin(i * 0.055) * 6.2 + Math.sin(i * 0.017 + 2.1) * 4.8;
        const micro = Math.sin(i * 0.63) * 1.5;
        const jitter = (rand() - 0.5) * 5;
        // Muescas ocasionales: los tirones donde la fibra cedió de golpe.
        const nick = rand() > 0.955 ? rand() * 7 : 0;
        const y = H * 0.62 + macro + micro + jitter + nick;
        points.push([
            Math.round(x * 100) / 100,
            Math.round(Math.max(3, Math.min(H - 2, y)) * 100) / 100,
        ]);
    }
    return points;
}

// Segmentos rectos, nunca curvas: una curva suave se lee como líquido; el
// papel rasgado son microfacetas angulares.
const TEAR = buildTear(20170905);
const EDGE_D = TEAR.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x},${y}`).join(' ');
const FILL_D = `${EDGE_D} L${W},${H} L0,${H} Z`;

export default function TornEdge({ color = 'var(--paper-2)', className = '' }) {
    return (
        <div
            className={`relative w-full pointer-events-none ${className}`}
            style={{ lineHeight: 0 }}
            aria-hidden="true"
        >
            <svg
                viewBox={`0 0 ${W} ${H}`}
                preserveAspectRatio="none"
                className="block w-full"
                style={{
                    height: 'clamp(16px, 2.2vw, 30px)',
                    // La sombra cae hacia ARRIBA: la hoja de abajo está
                    // encima de la sección anterior, y es esa sombra la que
                    // hace leer el rasgado aunque los dos tonos sean casi
                    // iguales (papel sobre papel).
                    filter: 'drop-shadow(0 -2px 3px rgba(28, 26, 21, 0.10))',
                }}
            >
                <path d={FILL_D} fill={color} />
                {/* Fibra del canto: el mismo color mezclado con kraft, así el
                    borde queda cálido tanto sobre papel como sobre tinta. */}
                <path
                    d={EDGE_D}
                    fill="none"
                    stroke={`color-mix(in srgb, ${color} 72%, var(--kraft))`}
                    strokeWidth="1.25"
                />
            </svg>
        </div>
    );
}
